/**
 */
define('constant/incentive/incentive.constant',[], function () {
    return {
        applyType: {
            "1": "首次验收",
            "2": "二次验收"
        },

        state : {
            "1":"验收中",
            "2":"验收通过",
            "3":"验收不通过"
        },
        billStatus: {
            'C010': '待发放',
            'D010': '待发放',
            'D020': '待发放',
            'C020': '待发放',
            'P010': '待发放',
            'P020': '待发放',
            'P030': '待发放',
            'P040': '待发放',
            'P050': '已发放',
            'P060': '已充值'
        },
        prodType:{
            "1":"移动应用",
            "30":"免安装应用"
        },
        promotePayMode:{
            "0":"现金",
            "1":"推广金"
        },
        serviceItems:[4,24,53,74],
        serviceOnlineStatus:[101,300,301]
    }
});

